const FERNET_TOKEN_PREFIX = 'gAAAAA'
const MULTI_REGION_PARTS = 3

type ParsedPublicApiKey = {
  environment: string
  region: string | undefined
}

const parsePublicApiKey = (publicApiKey: string): ParsedPublicApiKey => {
  const parts = publicApiKey.split('_')
  const environment = parts[0]

  if (parts.length >= MULTI_REGION_PARTS && parts[1] && !parts[1].startsWith(FERNET_TOKEN_PREFIX)) {
    return { environment, region: parts[1] }
  }

  return { environment, region: undefined }
}

const applyRegionToUrl = (url: string, region: string | undefined): string => {
  if (!region) return url
  return url.replace(/^(https?:\/\/|wss?:\/\/)([^./]+)\./, `$1$2.${region}.`)
}

const ApiKeyPrefixToEnvironmentSufix: { [key: string]: string } = {
  dev: '-dev',
  staging: '-staging',
  sandbox: '-sandbox',
  prod: '',
}

const generateBaseUrlApi = (
  publicApiKey: string,
  publicAPIurl: string,
): string => {
  const { environment: apiKeyPrefix, region } = parsePublicApiKey(publicApiKey)
  let baseURL = ''
  const environmentSufix = ApiKeyPrefixToEnvironmentSufix[apiKeyPrefix]

  if (environmentSufix === undefined) {
    throw new Error(
      `No environment found for publicApiKey: ${publicApiKey}, apiKeyPrefix: ${apiKeyPrefix}`
    )
  }

  baseURL = publicAPIurl.replace('_ENVIRONMENT_', environmentSufix)
  
  return applyRegionToUrl(baseURL, region)
}

export const getBaseUrl = (publicApiKey: string) => {
  return generateBaseUrlApi(
    publicApiKey,
    'https://api_ENVIRONMENT_.y.uno',
  )
}
